import React from 'react';
import { withRouter } from "react-router"
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";
import { Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore';
import RelationSubjectsData from './relationSubjectsData';
import { Circles } from '../../common/loadingComponent';
import { isNullOrUndefined } from '../../../store/storeFunctions';

class RelationsAddressesData extends React.Component {

    componentDidMount() {
        this.props.requestRelatedAddressData(this.props.match.params.id, this.props.match.params.idAddress);
    }

    render() {
        return (
            <React.Fragment>
                <div className='content-root'>
                    <div className='card card-special'>
                        <div className='card-body'>
                            {this.props.relatedAddress.isLoading && <Circles/>}
                            {this.renderAddress(this.props.relatedAddress.data)}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
    renderAddress = (data) => {
        if (data === undefined || data === null)
            return null;

        if (data.companies === undefined || data.companies === null || data.companies.length === 0)
            return null;

        const actualData = data.companies.filter(x => x.isActive);
        const historicalData = data.companies.filter(x => !x.isActive);

        return (
            <div className="report-section-related-address">
                <div className={'header-wrap'}>
                    <div className="header-body">
                        <div className="name">{`${data.fullAddress} (${data.type})`}</div>
                    </div>
                </div>
                {!isNullOrUndefined(actualData) && actualData.length > 0 ? <RelationSubjectsData data={actualData} /> : <span className="no-actual-data"><Translate id="Report.Common.NoActualData" /></span>}
                <RelationSubjectsData data={historicalData} historicalRelations={true} />
            </div>
        )
    }
}

export default withRouter(withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(RelationsAddressesData)));